import React, { useState } from "react";
import { useTable, useSortBy, useFilters, useGlobalFilter } from "react-table";
import {
  ChakraProvider, Table, Thead, Tbody, Tr, Th, Td, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  useDisclosure, Container,
} from "@chakra-ui/react";


function CustomTable({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy,
    (hooks) => {
      hooks.allColumns.push((columns) => [
        ...columns,
      ]);
    }
  );

  return (
    <>
      <Table {...getTableProps()} width='80%' variant='striped' fontSize="small">
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th key={column.id}
                  {...column.getHeaderProps([
                    {
                      style: column.style,
                    }
                  ])}
                  isNumeric={column.isNumeric} sx={{bg: '#e8e2db', textAlign: 'center', border:'0.5px solid black',
                    p:'4px', fontSize:"x-small"}}
                >
                  {column.render('Header')}
                  {/* Render the columns filter UI */}
                  <div>{column.canFilter ? column.render("Filter") : null}</div>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {rows.map((row) => {
          prepareRow(row)
          return (
            <Tr {...row.getRowProps()}>
              {row.cells.map((cell) => (
                <Td {...cell.getCellProps()} isNumeric={cell.column.isNumeric}
                  sx={{padding: '4px', textAlign: 'center'}}>
                  {cell.render('Cell')}
                </Td>
              ))}
            </Tr>
          )
        })}
        </Tbody>
      </Table>
    </>
  );
}

const TableAdrPrMzl = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Дата',
        accessor: 'data_vremya',
        disableFilters: true,
        Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
      },
      {
        Header: 'Адрес',
        accessor: 'adres',
        disableFilters: true,
        Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
      },
      {
        Header: 'МЗЛ',
        accessor: 'meneger',
        disableFilters: true,
        Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
      },
      {
        Header: 'Цена',
        accessor: 'price',
        disableFilters: true,
        Cell: row => <div>{row.value ? Number(row.value).toLocaleString('de-CH') : 0}</div>
      },
    ],
    [],
  )

  const modal1 = useDisclosure();

  const [data_m, setData_m] = useState([]); // use an empty array as initial value

  const fetchPrice = async () => {
    const user_id = localStorage.getItem('session')

    const mzl = await fetch(`/api/check_fio_mzl/${user_id}`, {method: "GET"});
    const data_mzl = await mzl.json()
    const meneger = data_mzl.data[0]['fio']

    const response = await fetch(`/api/actual_adr_mzl/${meneger}`, {method: "GET"});

    const data_m = await response.json()
    setData_m(data_m.data)
  };

  return (
    <Container p={0}>
      <Button
        bg='#D1EE68'
        onClick={() => {
          fetchPrice();
          modal1.onOpen();
        }}
      >
        Адреса
      </Button>
      <Modal isOpen={modal1.isOpen} size={'xl'} onClose={modal1.onClose}>
        <ModalOverlay />
        <ModalContent textAlign='center'>
          <ModalHeader>Список адресов со спец ценами</ModalHeader>
          <ModalCloseButton />
          <ModalBody align='center' pb='20px'>
            <ChakraProvider>
              <CustomTable columns={columns} data={data_m} />
            </ChakraProvider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default TableAdrPrMzl;